module.exports = __webpack_public_path__ + "img/laspi1.26e98e58.png";